/**
 * Screen Resize Wrapper
 *
 */

import React from 'react'
import { Consumer } from './ResizeContext'

export default WrappedComponent => ({observedBits, ...rest}) => {
  return (
    <Consumer unstable_observedBits={observedBits}>
      {
        ( providerValues ) => {
          return <WrappedComponent {...providerValues} {...rest} />
        }
      }
    </Consumer>
  )

}



// WEBPACK FOOTER //
// ./src/Context/WithResize.js